import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { artistsAPI } from '../services/api';

function Artists() {
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadArtists();
  }, []);

  const loadArtists = async () => {
    try {
      const response = await artistsAPI.getAll();
      // Ensure we always have an array
      const data = response?.data || [];
      setArtists(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error loading artists:', error);
      setArtists([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section id="artists" className="artists-section">
        <div className="container">
          <h2 className="section-title">ARTISTS</h2>
          <div className="artists-grid">
            <p style={{ color: '#a0a0a0', textAlign: 'center', gridColumn: '1 / -1' }}>Loading artists...</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="artists" className="artists-section">
      <div className="container">
        <h2 className="section-title">ARTISTS</h2>
        <div className="artists-grid">
          {!Array.isArray(artists) || artists.length === 0 ? (
            <>
              <div className="artist-card">
                <div className="artist-image-placeholder"></div>
                <h3 className="artist-name">Artist Name</h3>
              </div>
              <div className="artist-card">
                <div className="artist-image-placeholder"></div>
                <h3 className="artist-name">Artist Name</h3>
              </div>
              <div className="artist-card">
                <div className="artist-image-placeholder"></div>
                <h3 className="artist-name">Artist Name</h3>
              </div>
              <div className="artist-card">
                <div className="artist-image-placeholder"></div>
                <h3 className="artist-name">Artist Name</h3>
              </div>
            </>
          ) : (
            artists.slice(0, 8).map((artist) => (
              <Link 
                key={artist.id} 
                to={`/artists/${artist.id}`}
                style={{ textDecoration: 'none', color: 'inherit', display: 'block', height: '100%' }}
              >
                <div className="artist-card" style={{ cursor: 'pointer' }}>
                  <div 
                    className="artist-image-placeholder"
                    style={artist.image ? {
                      backgroundImage: `url(${artist.image})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    } : {}}
                  ></div>
                  <h3 className="artist-name">{artist.name}</h3>
                </div>
              </Link>
            ))
          )}
        </div>
        {artists.length > 0 && (
          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <Link 
              to="/artists" 
              style={{ 
                color: '#228b22', 
                textDecoration: 'none', 
                fontSize: '1.2rem',
                fontFamily: 'Bungee, cursive',
                border: '2px solid #228b22',
                padding: '12px 30px',
                display: 'inline-block',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#228b22';
                e.target.style.color = '#000';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = '#228b22';
              }}
            >
              VIEW ALL ARTISTS →
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}

export default Artists;

